var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1000008655(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.5289,
    height: 14.5289,
    rx: 7.26445,
    fill: "#F7B53C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.97656 7.68393L5.93945 9.64704L11.0429 4.54297",
    stroke: "black",
    strokeWidth: 1.35892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008655);
export default __webpack_public_path__ + "static/media/Group 1000008655.d50ab8a97978dd0f43e80331c7bc3176.svg";
export { ForwardRef as ReactComponent };